import React from "react";
import { TrackingSection } from "../components/TrackingSection";
import { Phone, MessageCircle } from "lucide-react";
import { Button } from "../components/ui/button";
import { businessInfo } from "../data/mock";

export default function TrackPage() {
  return (
    <div>
      {/* Page Header */}
      <section className="bg-brand-dark py-14 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-sm font-semibold text-brand-light uppercase tracking-wider mb-2">Shipment Tracking</p>
          <h1 className="text-3xl sm:text-4xl font-bold text-white" style={{ fontFamily: "'Lora', serif" }}>Track Your Shipment</h1>
          <p className="text-white/70 mt-3 max-w-2xl text-base">Enter your Om Sai Express docket number to get real-time status updates on your shipment.</p>
        </div>
      </section>

      {/* Tracking Section */}
      <section className="bg-white py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <TrackingSection compact />
        </div>
      </section>

      {/* Help Section */}
      <section className="bg-gray-50 py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Lora', serif" }}>Need Help with Tracking?</h3>
          <p className="text-gray-500 text-sm mb-6 max-w-lg mx-auto">
            If you're unable to track your shipment or have questions about your delivery, contact us directly.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Button asChild className="bg-brand hover:bg-brand-dark text-white font-semibold">
              <a href={`tel:${businessInfo.phone}`}>
                <Phone className="w-4 h-4" />
                Call {businessInfo.phone}
              </a>
            </Button>
            <Button asChild className="bg-[#25D366] hover:bg-[#1da851] text-white font-semibold">
              <a href={businessInfo.whatsappLink} target="_blank" rel="noopener noreferrer">
                <MessageCircle className="w-4 h-4" />
                WhatsApp Us
              </a>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
}
